import axios from "axios";
import User from "../models/user";
import store from "@/store";
import authHeader from "./auth-header";
import environments from "../utils/environments";

const API_URL = environments.apiUrl + "/api/auth/userdata/";

class UserDataService {
  getHasOpenSkontoVouchers() {
    return axios.get(API_URL + "skontovouchers").then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }
      return response.data;
    });
  }
}

export default new UserDataService();
